/* eslint-disable react/require-default-props */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { Button } from '../../../../components/Buttons/Button/Button';
import { FontAwesome } from '../../../../components/FontAwesome';
import { makeMetricsLogEvent } from '../../../../../ReduxStorage/Metrics/manualEventDispatchers';

export class _ProfileHeaderShare extends PureComponent {
  static propTypes = {
    user: ImmutablePropTypes.map,
    profilePage: ImmutablePropTypes.map,
    updateProfilePageShareShow: PropTypes.func,
    profileShareLink: PropTypes.string,
    page: PropTypes.string,
    metricsLogEvent: PropTypes.func.isRequired,
  };

  onCopyClick = () => {
    const {
      user,
      updateProfilePageShareShow,
      page,
      metricsLogEvent,
    } = this.props;

    metricsLogEvent('ProfileLink-Shared', {
      tab: page,
    });

    updateProfilePageShareShow(user.get('profileName'), true);
  };

  render() {
    const { profilePage, profileShareLink } = this.props;
    const shareShow = profilePage.get('shareShow', false);

    return (
      <div
        className={classnames('header-share', {
          'header-share-show': shareShow,
        })}
      >
        {shareShow ? (
          <div className="header-share-text">
            <FontAwesome name="check" /> Link copied to clipboard, paste to
            share
            <a className="header-share-link" href={profileShareLink}>
              {profileShareLink}
            </a>
          </div>
        ) : (
          <CopyToClipboard onCopy={this.onCopyClick} text={profileShareLink}>
            <Button
              label="Copy link to share"
              icon="link"
              className="header-share-button"
            />
          </CopyToClipboard>
        )}
      </div>
    );
  }
}

export const ProfileHeaderShare = connect(undefined, {
  metricsLogEvent: makeMetricsLogEvent,
})(_ProfileHeaderShare);
